import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import styled from 'styled-components';
import { Flex, media } from 'lib/style-utils';

const Wrapper = Flex.extend`
  flex-direction: column;
  align-items: space-between;
  width: 100%;
  height: 280px;
  padding: 0 100px;
  position: absolute;
  bottom: 194px;
  left: 0;
  background-color: #292929;
  z-index: 25;

  ${media.w1200`
    height: auto;
  `}
  ${media.w800`
    bottom: 187px;
  `}
  ${media.mobile`
    position: static;
    height: 370px;
    padding: 0 40px;
  `}
`;

const RowWrapper = Flex.extend`
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  margin: 0 auto;
  padding-top: 50px;

  &.first {
    height: 168px;
    border-bottom: 1px solid #3b3b3b;

    ${media.w1200`
      height: 254px;
    `}
    ${media.tablet`
      height: 300px;
    `}
    ${media.mobile`
      height: 254px;
    `}
  }
  &.second {
    height: 111px;

    ${media.w1200`
      height: auto;
    `}
  }

  ${media.w1200`
    flex-direction: column;
  `}
  ${media.mobile`
    padding-top: 29px;
  `}
`;

const GroupName = styled.div`
  width: 10%;
  font-family: Lato;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.4px;
  text-align: left;
  color: #9c9c9c;

  .space {
    line-height: 38px;
  }

  ${media.w1200`
    width: 100%;
    margin-bottom: 30px;
  `}
  ${media.mobile`
    font-size: 13px;
    margin-bottom: 30px;
    letter-spacing: 0.8px;

    .space {
      line-height: 18px;
    }
  `}
`;


const BrandsWrapper = styled.ul`
  width: 80%;
  margin-left: 10%;

  ${media.w1440`
    width: 85%;
    margin-left: 5%;
  `}
  ${media.w1200`
    margin: 0 auto;
    width: 100%;
  `}
`;

const Brands = styled.li`
  float: left;
  margin: 0 0 40px 1%;
  width: 20%;
  font-family: Lato;
  font-size: 14px;
  letter-spacing: 0.4px;
  text-align: left;
  color: #888888;
  transition: all .5s;

  &.lastItem {
    width: 15%;

    ${media.w1200`
      width: 25%;
    `}
    ${media.tablet`
      width: 33%;
    `}
    ${media.tablet`
      width: 50%;
    `}
  }

  ${media.w1200`
    margin-left: 0;
    width: 25%;
  `}
  ${media.tablet`
    margin-left: 0;
    width: 33%;
  `}
  ${media.w800`
    width: 50%;
    margin-bottom: 20px;
  `}
  ${media.mobile`
    font-size: 12px;
    margin-bottom: 31px;
  `}
`;

const Brand = styled.p`
  display: inline-block;
  width: 100%;
  padding-left: 50px;

  & > a {
    padding-bottom: 3px;
  }
  & > a: hover {
    border-bottom: 1px solid #959595;
  }

  ${media.w1440`
    padding-left: 0;
  `}
`;

class AnotherBrands extends Component {

  componentDidMount() {
    if (window.innerWidth < 600) {
      const anotherBrands = findDOMNode(this.another);

      if (document.documentElement && document.documentElement.scrollTop) {
        document.documentElement.scrollTop = anotherBrands.offsetTop - 70;
      } else {
        document.body.scrollTop = anotherBrands.offsetTop - 70;
      }
    }
  }

  render() {
    return (
      <Wrapper innerRef={ref => this.another = ref}>
        <RowWrapper className="first">
          <GroupName>GURM BY H<br/><span className="space">BABY&amp;KIDS</span></GroupName>
          <BrandsWrapper>
            <Brands><Brand><a href="https://www.albaofdenmark.co.kr" rel="noopener noreferrer">ALBA ORIGINAL</a></Brand></Brands>
            <Brands><Brand><a href="/" rel="noopener noreferrer">BABY DEEDEE</a></Brand></Brands>
            <Brands><Brand><a href="https://www.carlotabarnabe.co.kr" rel="noopener noreferrer">CARLOTA BARNABE</a></Brand></Brands>
            <Brands><Brand><a href="https://www.dunssweden.co.kr" rel="noopener noreferrer">DUNS SWEDEN</a></Brand></Brands>
            <Brands className="lastItem"><Brand><a href="https://www.lilybalou.co.kr" rel="noopener noreferrer">LILY BALOU</a></Brand></Brands>
            <Brands><Brand><a href="https://www.morethanafling.co.kr" rel="noopener noreferrer">MORE THAN A FLING</a></Brand></Brands>
            <Brands><Brand><a href="https://www.smafolk.co.kr" rel="noopener noreferrer">SMAFOLK</a></Brand></Brands>
          </BrandsWrapper>
        </RowWrapper>

        <RowWrapper className="second">
          <GroupName>GBH LIVING</GroupName>
          <BrandsWrapper>
            <Brands><Brand><a href="https://www.tubtrugskorea.com" rel="noopener noreferrer">TUBTRUGS</a></Brand></Brands>
            <Brands><Brand><a href="https://www.alchemyprodux.co.kr" rel="noopener noreferrer">ALCHEMY PRODUX</a></Brand></Brands>
          </BrandsWrapper>
        </RowWrapper>
      </Wrapper>
    );
  };
}
export default AnotherBrands;



// WEBPACK FOOTER //
// ./src/components/Shared/AnotherBrands.js